import my_profile_route from "./modules/my_profile_route";
import retailer_dashboard_route from "./modules/retailer_dashboard_route";

const routes = [
    ...my_profile_route, 
    ...retailer_dashboard_route,
];

export default routes;